import { render } from "./comp-model.vue?vue&type=template&id=1326f7c5"
import script from "./comp-model.vue?vue&type=script&lang=js"
export * from "./comp-model.vue?vue&type=script&lang=js"

import "./comp-model.vue?vue&type=style&index=0&id=1326f7c5&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__